import { schema } from 'normalizr';

import { NotificationModel } from '@/store/models/Notification';

export const notificationSchema = new schema.Entity<NotificationModel>('notifications');

export const notificationListSchema = new schema.Array(notificationSchema);
